module.exports = __webpack_public_path__ + "static/img/review@2x.51b9a565.png";